import { render, staticRenderFns } from "./ProductTourOverlay.vue?vue&type=template&id=af71215c"
import script from "./ProductTourOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTourOverlay.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports